import React from 'react';
import globals from '../../globals.json';

const Popup = props => {
    return (
        <div className={`Popup ${props.class ? props.class : ''} ${props.data.class}`}>
            <div className={`flex-container`}>
                <div className={`popup-content`}>
                    {props.data.imageClass && 
                        <div className={`image ${props.data.imageClass}`} />
                    }
                    <div className={`popup-header`} dangerouslySetInnerHTML={{__html: props.data.header || ''}} />
                    <div className={`popup-yellow-underline`} />
                    <div className={`popup-body`} dangerouslySetInnerHTML={{__html: props.data.body}} />
                    {props.data.additionalSection && 
                        <>
                            <div className={`additional-popup-header`} dangerouslySetInnerHTML={{__html: props.data.additionalSection.header || ''}} />
                            <div className={`additional-popup-yellow-underline`} />
                            <div className={`additional-popup-body`} dangerouslySetInnerHTML={{__html: props.data.additionalSection.body}} />
                        </>
                    }
                    {props.additionalButton && props.additionalButton}
                    {props.onCancel &&
                        <div className={`global-button cancel-button`} onClick={props.onCancel}>{props.data.cancelButtonText || globals.cancelButtonText}</div>
                    }
                    <div className={`global-button continue-button`} onClick={props.onComplete}>{props.data.buttonText || globals.continueButtonText}</div>
                </div>
                <div className={`scrim`} />
            </div>
        </div>
    )
}

export default Popup